module.exports = __webpack_public_path__ + "img/icon-eye.8abe780f.svg";